import { Icon } from '@iconify/react'

const StatCard = ({
  icon,
  iconColor = 'blue',
  value,
  label,
  change,
  changeType = 'positive',
  className = '',
}) => {
  const iconColors = {
    blue: 'bg-blue-50 text-blue-600',
    green: 'bg-green-50 text-green-600',
    orange: 'bg-orange-50 text-orange-600',
    cyan: 'bg-cyan-50 text-cyan-600',
  }

  return (
    <div className={`bg-white rounded-lg border border-gray-200 p-4 ${className}`}>
      <div className="flex items-start justify-between">
        <div className="flex items-center gap-3">
          <div className={`w-10 h-10 rounded-lg flex items-center justify-center text-xl flex-shrink-0 ${iconColors[iconColor]}`}>
            <Icon icon={icon} />
          </div>
          <div>
            <p className="text-xs text-gray-500 mb-0.5">{label}</p>
            <h3 className="text-xl font-bold text-gray-800">{value}</h3>
          </div>
        </div>
        {change && (
          <div className={`text-xs font-medium flex items-center gap-0.5 px-1.5 py-0.5 rounded ${
            changeType === 'positive'
              ? 'text-green-600 bg-green-50'
              : 'text-red-600 bg-red-50'
          }`}>
            <Icon
              icon={changeType === 'positive' ? 'mdi:arrow-up' : 'mdi:arrow-down'}
              className="text-sm"
            />
            <span>{change}</span>
          </div>
        )}
      </div>
    </div>
  )
}

export default StatCard
